// This icon file is generated automatically.
var DrrpDatasupermarketIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M18.9 33.75a1.88 1.88 0 110 3.75 1.88 1.88 0 010-3.75zm10 0a1.88 1.88 0 110 3.75 1.88 1.88 0 010-3.75zM5.8 2.51A2.5 2.5 0 018.2 4.36l1.25 4.62H35.4c.78 0 1.5.36 1.98.98s.63 1.4.43 2.16l-2.97 11.22a2.5 2.5 0 01-2.41 1.86H13.8l1.21 4.49h17.32a1.25 1.25 0 010 2.5H15.02a2.5 2.5 0 01-2.41-1.85L5.8 5H3.7a1.25 1.25 0 010-2.5zm29.6 8.97H10.14l3.01 11.22h19.3l2.97-11.22z", "fill-rule": "nonzero" } }] }, "name": "drrp-datasupermarket-icon", "theme": "outlined" };
export default DrrpDatasupermarketIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpDatasupermarketIconOutlined.js
// module id = 2557
// module chunks = 0